"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tagPickerOptionGroupClassNames: function() {
        return tagPickerOptionGroupClassNames;
    },
    useTagPickerOptionGroupStyles: function() {
        return useTagPickerOptionGroupStyles;
    }
});
const _react = require("@griffel/react");
const _reactcombobox = require("@fluentui/react-combobox");
const tagPickerOptionGroupClassNames = {
    root: 'fui-TagPickerOptionGroup',
    label: 'fui-TagPickerOptionGroup__label'
};
const useTagPickerOptionGroupStyles = (state)=>{
    'use no memo';
    (0, _reactcombobox.useOptionGroupStyles_unstable)(state);
    state.root.className = (0, _react.mergeClasses)(tagPickerOptionGroupClassNames.root, state.root.className);
    if (state.label) {
        state.label.className = (0, _react.mergeClasses)(tagPickerOptionGroupClassNames.label, state.label.className);
    }
    return state;
}; //# sourceMappingURL=useTagPickerOptionGroupStyles.styles.js.map
